import NotificationService from "./NotificationService";

// Legacy function for backward compatibility
export const requestForToken = async () => {
  try {
    const success = await NotificationService.initialize();
    if (success) {
      console.log("FCM initialized successfully");
    } else {
      console.log("FCM initialization failed");
    }
    return success;
  } catch (error) {
    console.error("Error initializing FCM:", error);
    return false;
  }
};

// Export notification service for direct use
export { default as NotificationService } from "./NotificationService";
